import React, {FC} from 'react';

import {VisualCustomView} from '../../../../helpers/models/customViewHelpers';
import {TeamModel} from '../../../../models/api/teamModel';
import {WorkspaceDropReorderTeamViewHandler} from '../../../../store/data/workspace/reorder/types';
import {VisualWorkspaceRecentlyViewedMap} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceHelpers';
import {InboxesPanelId} from '../../../../store/panels/panelStateBase';
import {TeamWorkspaceCustomViewItemContainer} from '../teamWorkspace/teamWorkspaceCustomViewItemContainer';
import {ToggleTeamCustomViewHandler} from './context/types';

/*
 * Props.
 */

interface TeamWorkspaceEditorCustomViewsProps {
  panelId: InboxesPanelId;
  team: TeamModel;
  visualCustomViews: ReadonlyArray<VisualCustomView>;
  onToggle: ToggleTeamCustomViewHandler;
  onDropReorderTeamView: WorkspaceDropReorderTeamViewHandler;
  recentlyViewedMap: VisualWorkspaceRecentlyViewedMap;
}

/*
 * Component.
 */

export const TeamWorkspaceEditorCustomViews: FC<TeamWorkspaceEditorCustomViewsProps> = (props) => {
  const {panelId, team, visualCustomViews, onToggle, onDropReorderTeamView, recentlyViewedMap} = props;

  const lastIndex = visualCustomViews.length - 1;
  return (
    <>
      {visualCustomViews.map((visualCustomView, index) => (
        <TeamWorkspaceCustomViewItemContainer
          panelId={panelId}
          team={team}
          key={visualCustomView.id}
          customView={visualCustomView}
          hasEditPermission={false}
          isLastInList={index === lastIndex}
          isChecked={visualCustomView.isVisibleInWorkspace}
          onClick={() => onToggle({id: visualCustomView.id, teamId: team.id}, false)}
          isEditingWorkspace
          shouldAlphabetizeWorkspace={false}
          onDropReorderTeamView={onDropReorderTeamView}
          isRecentlyViewed={recentlyViewedMap[visualCustomView.id]}
        />
      ))}
    </>
  );
};
